export default __webpack_public_path__ + "static/media/PelvicObliquity.c63a2f3c.png";